
export class UserTableDefaults {
  /**
   * Default id autoincrement setting
   */
  static DEFAULT_AUTOINCREMENT: boolean = true;

  /**
   * Default primary key not null setting
   */
  static DEFAULT_PK_NOT_NULL: boolean = true;
}
